var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"mb-8",attrs:{"app":"","dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_c('v-spacer'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }